import React, { useEffect } from 'react';

import ExperimentViewTable from "./ExperimentViewTable";
import OpenIssuesTable from "./OpenIssuesTable";

import { useDispatch } from 'react-redux';
import { fetchExperiments, fetchFiles } from '../store/ExperimentSlice';
import { fetchIssues } from '../store/IssuesSlice';
import { Synopsis } from './Synopsis';

export default function Overview({ username }) {
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(fetchFiles()).then(filesAction => {
      dispatch(fetchExperiments(filesAction.payload)).then(experimentsAction => {
        dispatch(fetchIssues(experimentsAction.payload))
      })
    })  
  }, [dispatch]);

  return (
    <>
      <div id="signedIn">
        <div id="welcome">
          <h1>Welcome {username}!</h1>
        </div>
        <Synopsis/>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <ExperimentViewTable></ExperimentViewTable>
          <OpenIssuesTable></OpenIssuesTable>
        </div>
      </div>
    </>
  );
}

